import { Box, Text } from '@factorialco/deprecated-design-system'

import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  payrollCalculationStartedAt: string | null
}

const CalculationStatusNotice = ({ payrollCalculationStartedAt }: Props) => {
  return (
    <Box gap="s24">
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        paddingY="s16"
        paddingX="s24"
      >
        {payrollCalculationStartedAt ? (
          <Text.Normal color="grey1000" size="300">
            {i18n.t('payroll_bundle.export.payroll_calculation_status_notice.calculation_started', {
              day: convertDate(payrollCalculationStartedAt, 'backend_datetime', 'ui_dm_long'),
              time: convertDate(payrollCalculationStartedAt, 'backend_datetime', 'ui_time'),
            })}
          </Text.Normal>
        ) : (
          <Text.Normal color="grey1000" size="300">
            {i18n.t(
              'payroll_bundle.export.payroll_calculation_status_notice.calculation_not_started'
            )}
          </Text.Normal>
        )}
      </Box>
    </Box>
  )
}

export default CalculationStatusNotice
